var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3535 4.35355C14.5488 4.15829 14.5488 3.84171 14.3535 3.64645L11.1716 0.464465C10.9763 0.269203 10.6597 0.269203 10.4645 0.464465C10.2692 0.659727 10.2692 0.97631 10.4645 1.17157L13.2929 4L10.4645 6.82843C10.2692 7.02369 10.2692 7.34027 10.4645 7.53553C10.6597 7.7308 10.9763 7.7308 11.1716 7.53553L14.3535 4.35355ZM4.37114e-08 4.5L14 4.5L14 3.5L-4.37114e-08 3.5L4.37114e-08 4.5Z",
    fill: "#0D8ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlu);
export default __webpack_public_path__ + "static/media/arrow-blu.2c854b5845a9ccb4982c353c1209a4e6.svg";
export { ForwardRef as ReactComponent };